import React from 'react'

const TheAmenities = () => {
  return (
    <div className='flex flex-col gap-4 py-3 lg:pr-3'>
      <h2 className='font-semibold text-[16px] md:text-[18px]'>The Amenities</h2>
      <p className='text-[14px] md:text-[17px]'>The tiny suite has been designed to maximize comfort and invite nature in at every angle.</p>
      <p className='text-[14px] md:text-[17px]'>Equipped with a cozy Queen size bed, micro-chef’s kitchen (two burner stovetop, mini-fridge, sink with built-in cutting board), comfortable bar stools, a floating eating bar and a luxurious, fully functional bathroom.</p>
      <p className='text-[14px] md:text-[17px]'>Each suite provides an outdoor private area with all the amenities necessary to relax and enjoy doing nothing, for a change. (this includes a picnic table, inviting lounge chairs and a fire pit with a grill).</p>
    </div>
  )
}

export default TheAmenities